var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.config.card,_vm._b({ref:"hotelCard",tag:"component",class:_vm.config.cardClasses && _vm.config.cardClasses},'component',_vm.propsToBind(_vm.hotel),false))}
var staticRenderFns = []

export { render, staticRenderFns }